import React from 'react';
import { Link } from 'react-router-dom';

import arrow from '@app/images/arrow_circle.svg';

interface LinkMoreProps {
	linkMoreCaption: string;
	linkMoreHref: string;
	linkMoreState?: any
	classNameAdd?: string;
	target?: React.HTMLAttributeAnchorTarget;
	linkBack?: boolean;
	handleCLick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const LinkMore: React.FC<LinkMoreProps> = ({
	linkMoreCaption,
	linkMoreHref,
	linkMoreState,
	classNameAdd = '',
	target = '_self',
	linkBack = false,
	handleCLick = (e) => e.stopPropagation(),
}) => {
	return (
		<Link
			to={linkMoreHref}
			state={linkMoreState}
			target={target}
			className={linkBack ? `link-more link-more__back ${classNameAdd}` : `link-more ${classNameAdd}`}
			onClick={handleCLick}
		>
			<span>{linkMoreCaption}</span>
			<img src={arrow} alt="arrow" className="link-more-img" />
		</Link>
	);
};

export default LinkMore;
